import { Tab } from '@headlessui/react';
import classNames from 'classnames';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import UpdateUserInfoForm from './UpdateUserInfoForm';
import UpdateUserPassword from './UpdatePasswordForm';
import Helpers from 'helpers/Helpers';
import { RootState } from 'app/store';
import { CONFIG_WEBSITE } from 'global/Global';
import Layout from '@components/common/Layout';
import { Avatar, Button, message } from 'antd';
import AuthServiceApi from 'apis/api/Auth';
import { getUserCurrent } from '@slice/user.slice';
import { ThunkDispatch } from '@reduxjs/toolkit';
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = reject;
  });
}

export default function UserInfo() {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const { t } = useTranslation();
  const account = useSelector((state: RootState) => state.user.account);
  const branchsData = useSelector((state: RootState) => state.select.branchSelectData);
  const technicianZoneData = useSelector((state: RootState) => state.select.technicianZoneSelectData);
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const [clickOutSide, setClickOutSide] = useState<boolean>(false);
  const [confirmLoading, setConfirmLoading] = useState<boolean>(false);
  const inputRef = useRef<any>();
  const [avatarUser, setAvatarUser] = useState<File>();

  const onChooseFile = () => {
    inputRef.current.click();
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const isJpgOrPng = e.target.files[0]?.type === 'image/jpeg' || e.target.files[0]?.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!');
    }

    if (e.target.files) {
      const data = [e.target.files[0]];
      setAvatarUser(data[0]);
    }
  };

  const handleFormSubmit = async (evt: any) => {
    const base64 = await getBase64(evt) // `file` your img file
      .then((res: string) => {
        return res.replace(/^data:image\/[a-z]+;base64,/, '');
      })
      .catch(err => console.log(err));

    const dataBody = {
      base64: evt ? base64 : ''
    };
    try {
      if (dataBody) {
        // console.log('dataBody', dataBody);
        setConfirmLoading(true);
        await AuthServiceApi.UpdateUserAvatar(dataBody).then(res => {
          if (!res.data.error) {
            dispatch(getUserCurrent());
            message.success(t('Header.UserAcount.Success.UploadAvatarSuccess'));
          } else {
            message.error(t('Header.UserAcount.Error.UploadAvatarError'));
          }
          setConfirmLoading(false);
        });
      }
    } catch (error) {
      console.log(error);
      setConfirmLoading(false);
      message.error(t('Header.UserAcount.Error.UploadAvatarError'));
    }
  };

  const renderAvatar = useMemo(() => {
    return (
      <div className="image overflow-hidden text-center m-auto flex justify-center">
        <input ref={inputRef} type="file" multiple onChange={handleFileChange} style={{ display: 'none' }} />
        <Avatar
          className="cursor-pointer "
          onClick={() => onChooseFile()}
          src={avatarUser ? URL.createObjectURL(avatarUser) : `${process.env.REACT_APP_URL_AUTH + account.avatar}`}
          size={100}
          style={{
            color: '#f56a00',
            backgroundColor: account.avatar ? '' : '#fde3cf'
          }}
        >
          {Helpers.FormatNameAccountAvt(
            (account && account.displayName) || '',
            (account && account.username) || '',
            'userName'
          )}
        </Avatar>

        {/* )} */}
      </div>
    );
  }, [account, avatarUser]);

  return (
    <Layout path={[{ name: 'UserInfo' }]}>
      <div className="container mx-auto mb-2 p-5">
        <div className="md:flex no-wrap md:-mx-2 ">
          <div className="w-full md:w-3/12 md:mx-2" onClick={() => setClickOutSide(!clickOutSide)}>
            <div className="bg-white p-1 shadow-sm rounded-md border">
              {avatarUser && <Button onClick={() => handleFormSubmit(avatarUser)}>Lưu Avatar</Button>}
              <div className="text-center">
                {renderAvatar}
                <h1 style={{ fontFamily: 'roboto' }} className="text-gray-900 font-bold text-xl leading-8 my-1">
                  {account?.displayName}
                </h1>

                <h3
                  style={{
                    fontFamily: 'roboto',
                    color: `${account && Helpers.FormatRoleTitle(account.role, true)}`
                  }}
                  className="font-lg text-semibold leading-6"
                >
                  {account && t(Helpers.FormatRoleTitle(account.role))}
                </h3>
              </div>

              <ul className="ffs-text bg-gray-100 text-gray-600 hover:text-gray-700 hover:shadow py-0 px-3 mt-3 divide-y rounded shadow-sm">
                <li className="flex items-center py-2">
                  <span>{t('Header.UserAcount.GroupUser')}</span>

                  <span className="ml-auto">
                    <span
                      style={{ backgroundColor: `${account && Helpers.FormatRoleTitle(account.role, true)}` }}
                      className={'py-1 px-2 rounded text-white text-sm'}
                    >
                      {account.isHeadOfDepartment && 'TP'} {account && t(Helpers.FormatRoleTitle(account.role))}
                    </span>
                  </span>
                </li>

                <li className="flex items-center py-2">
                  <span>{t('Header.UserAcount.InBranch')}</span>

                  <span className="ml-auto">
                    {branchsData.find(branch => branch.id == account?.companyBranchId)?.name || 'NOT'}
                  </span>
                </li>
                <li className="flex items-center py-2">
                  <span>{t('Header.UserAcount.AccountantSupport')}</span>

                  <span className="ml-auto">
                    {account.accountantSupport.length > 1
                      ? `${account.accountantSupport[0]} + ${+account.accountantSupport.length - 1}`
                      : account.accountantSupport.length > 0
                      ? account.accountantSupport
                      : 'NOT'}
                  </span>
                </li>
                <li className="flex items-center py-2">
                  <span>{t('Header.UserAcount.ZoneTech')}</span>

                  <span className="ml-auto">
                    {technicianZoneData.find(zone => zone.id == account?.technicianZoneId)?.name || 'NOT'}
                  </span>
                </li>
                <li className="flex items-center py-2">
                  <span>
                    {account && account.phone != null && account.phone != undefined
                      ? account.phone!.length > 11
                        ? account.phone!.slice(-11).replace(/^.{1,7}/, '*******')
                        : account?.phone!.replace(/^.{1,7}/, '*******')
                      : ''}
                  </span>

                  <span className="ml-auto">
                    {(account &&
                      account.email?.length != 0 &&
                      account.email.split('@')[0].replace(/^.{1,5}/, '***') + '@' + account.email.split('@')[1]) ||
                      'Email'}
                  </span>
                </li>

                <li className="flex items-center py-2">
                  <span>{CONFIG_WEBSITE.version}</span>

                  <span className="ml-auto">{CONFIG_WEBSITE.lastUpdate}</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="w-full md:w-9/12 mx-2 " onClick={() => setClickOutSide(!clickOutSide)}>
            <div className="bg-white p-3 shadow-sm rounded-md border h-full">
              <Tab.Group selectedIndex={selectedIndex} onChange={setSelectedIndex}>
                <Tab.List className="flex flex-wrap -mb-px border-b border-gray-200 dark:border-gray-700">
                  <Tab className={'outline-none'}>
                    <div
                      style={{ fontFamily: 'roboto' }}
                      className={classNames(
                        selectedIndex === 0
                          ? 'text-blue-400 border-b-2 border-blue-400 active'
                          : 'hover:text-gray-600 hover:border-gray-300 border-transparent ',

                        'inline-flex text-gray-500 rounded-t-lg py-4 px-4 text-base font-medium text-center  dark:text-gray-400 dark:hover:text-gray-300 group'
                      )}
                    >
                      {t('Header.UserAcount.UpdateInfo')}
                    </div>
                  </Tab>

                  <Tab className={'outline-none'}>
                    <div
                      style={{ fontFamily: 'roboto' }}
                      className={classNames(
                        selectedIndex === 1
                          ? 'text-blue-400 border-b-2 border-blue-400 active'
                          : 'hover:text-gray-600 hover:border-gray-300 border-transparent ',

                        'inline-flex text-gray-500 rounded-t-lg py-4 px-4 text-base font-medium text-center  dark:text-gray-400 dark:hover:text-gray-300 group'
                      )}
                    >
                      {t('Header.UserAcount.UpdatePassword')}
                    </div>
                  </Tab>
                </Tab.List>

                <Tab.Panels>
                  <Tab.Panel>
                    <UpdateUserInfoForm />
                  </Tab.Panel>

                  <Tab.Panel>
                    <UpdateUserPassword />
                  </Tab.Panel>
                </Tab.Panels>
              </Tab.Group>
            </div>
          </div>
        </div>

        <ul
          style={{ fontFamily: 'roboto' }}
          className="bg-gray-100 text-gray-600 hover:text-gray-700 hover:shadow py-2 px-3 mt-3 divide-y rounded shadow-sm"
        >
          <li className="flex py-3 space-x-4">
            <span className="md:block hidden whitespace-nowrap">{t('Header.UserAcount.PolicyCookie')}</span>
            <span className="ml-auto">{t('Header.UserAcount.PolicyCookieDetail')}</span>
          </li>
        </ul>
      </div>
    </Layout>
  );
}
